/**
 * Shell for Stories Pages.
 */
import "../../stylesheets/shared-package/shared.less";
import "../../stylesheets/stories-package/stories.less";

import {t} from "@lingui/core/macro";
import * as React from "react";

import {CircularSpinner} from "@khanacademy/wonder-blocks-progress-spinner";
import {HeadingMedium} from "@khanacademy/wonder-blocks-typography";

import PageRoot from "#app-shell-package/page-root.tsx";
import withLocation, {
    type WithLocationProps,
    type WithoutLocation,
} from "#data-access/with-location.tsx";

import {withStrings} from "./locales/stories-container/load-strings.tsx";
import StoriesQuery from "./queries/stories-query.tsx";
import StoriesPage from "./stories-page.tsx";

type Props = WithLocationProps;

class StoriesContainer extends React.Component<Props> {
    render(): React.ReactNode {
        const {location} = this.props;
        const {key} = location.queryParams;
        return (
            <PageRoot settings={{title: t`Stories`}}>
                <StoriesQuery>
                    {({loading, error, stories}) => {
                        if (loading) {
                            return <CircularSpinner size="medium" />;
                        }

                        if (error) {
                            return (
                                <HeadingMedium>
                                    {t`Error retrieving data.`}
                                </HeadingMedium>
                            );
                        }

                        return <StoriesPage stories={stories} focusKey={key} />;
                    }}
                </StoriesQuery>
            </PageRoot>
        );
    }
}

type ExportProps = WithoutLocation<
    JSX.LibraryManagedAttributes<
        typeof StoriesContainer,
        React.ComponentProps<typeof StoriesContainer>
    >
>;

export default withStrings(
    withLocation(StoriesContainer) as React.ComponentType<ExportProps>,
);
